import React from 'react';

import classnames from 'classnames/bind';

import CircularProgressIndicator from '@COMPONENTS/SHARED/CircularProgressIndicator';

import styles from './PageDataLoading.module.scss';

const cx: CX = classnames.bind(styles);

function PageDataLoading() {
    // Use CSS custom property for dynamic primary color
    const primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--marriott-primary').trim() || '#00a4ba';

    return (
        <div className={cx('page-data-loading')}>
            <CircularProgressIndicator
                color={primaryColor}
                size={50}
                thickness={5}
            />
        </div>
    );
}

export default PageDataLoading;
